import { Box } from '@chakra-ui/react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import TableComponent from 'UiKit/table-component';
import { Condition } from 'Component/others';

import { useReportState } from 'View/report/state';
import TableSkeleton from 'View/report/component/tableSkeleton';

import getTableList from './const';

import styles from './styles.module.css';

const Table = ({ isFetching, data }) => {
  const { t } = useTranslation('report-live');
  const { state, filterState, updateFilterState } = useReportState();

  const targetMonth = moment(filterState[state.selectedTab || 'brand']?.startedAt || new Date()).format('MMMM yyyy');

  const tableList = getTableList({
    selectedTab: state?.selectedTab,
    targetMonth,
    t,
  });

  const onChangePagination = (page) => updateFilterState({ page });
  const onChangeSort = (sort) => updateFilterState({ sort });

  return (
    <Box className={styles['table__container']}>
      <Box className={styles['table__wrapper']}>
        <Condition statement={!isFetching} fallback={<TableSkeleton selectedTab={state?.selectedTab} />}>
          <TableComponent
            tableName="table__reporting"
            onSort={onChangeSort}
            columns={tableList}
            dataSource={data?.reports}
            isScrollable
            isDataExist={data?.isDataExist}
            sortingData={filterState?.sort}
            verticalAlignBody="baseline"
            paddingBodyBox="0px"
            rowHeight="fit-content"
            maxTableHeight="calc(100vh - 362px)"
            maxTableBodyHeight="calc(100vh - 477px)"
            tableComponentHeight="calc(100vh - 305px)"
            pagination={{
              currentPage: filterState?.page,
              totalData: data?.totalData,
              onChange: onChangePagination,
              isLoading: isFetching,
            }}
          />
        </Condition>
      </Box>
    </Box>
  );
};

const MemoizedTable = memo(Table);

export default MemoizedTable;
